import { render, staticRenderFns } from "./OutUnpdClms.vue?vue&type=template&id=4ab8ae4a&"
import script from "./OutUnpdClms.vue?vue&type=script&lang=js&"
export * from "./OutUnpdClms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports